module.exports = __webpack_public_path__ + "static/img/squirrel-cup.49e89427.png";